module.exports = __webpack_public_path__ + "img/googleplay.067e2263.png";